var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.fileMaxSize')
    }
  }, [_c('el-input-number', {
    staticClass: "hide-spin-button",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "min": 1
    },
    model: {
      value: (_vm.optionModel.fileMaxSize),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "fileMaxSize", $$v)
      },
      expression: "optionModel.fileMaxSize"
    }
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-281ff62a","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/fileMaxSize-editor.vue
// module id = null
// module chunks = 